import React from "react";

const RenderUser = ({
 
  list,
  snackMessage,
  handleOnClick,
  handelDelete,
  search,
  onUpdate,
}) => {


  if (!list) return;

  return (
    <div className="row course-list list m-1">
      {list &&
        list.map((item, index) => {
         
            return (
              <div
                key={index}
                className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-3"
              >
                <div className="container-fluid">
                  <div className="d-flex justify-content-between mt-2">
                    <span className="badge rounded-pill bg-pill bg-secondary">
                      {index+1}
                    </span>
                  </div>
                  <div className="row no-gutters align-items-center justify-content-left">
                    <div className="col-auto text-center mb-2 p-1 text-center">
                    <div className="mytooltip tooltip-effect-1">
                      <span className="tooltip-item">

                      <img
                        src={item.url}
                       
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                        style={{
                          maxHeight: "350px",
                          Width: "100%",
                          maxWidth: "150px",
                        }}
                         onClick ={() => handleOnClick(item.url)}
                      ></img>
                      </span>

 {/* <span className="tooltip-content clearfix">
                        <img                        
                          src={item.url}
                          alt=""
                          style={{
                            width: "100%",
                            minHeight: "450px",
                            minWidth: "450px",
                          }}
                        />

                        <span className="tooltip-text"></span>
                      </span> */}
                      </div>

                         
                    </div>
                


                    <div className="col-auto ms-2">
                      <div className="card-body p-1">
                        <div className="card-text">
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: "14px" }}
                          >
                            {item.name}
                          </h6>
                        </div>

                        <h6>
                          <div
                            className="card-text"
                            style={{ fontSize: "14px" }}
                          >
                            <span className="card-text">
                              <span aria-hidden="true" /> {"id:"}
                           
                                <span
                                
                                  style={{
                                   
                                    fontSize: "12px",
                                  }}
                             
                                >
                                  {"  "}
                                  {item.ReqID}
                                </span>
                             
                            
                            </span>
                          </div>
                        </h6>

                   
                       
                     
                      
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          
        })}

    </div>
  );
};

export default RenderUser;
